import React from 'react';
import { PlusIcon } from 'lucide-react';
import { Product } from '../types/catalog';
import { formatPrice, useCart } from '../contexts/CartContext';
const stockLabel: Record<Product['stock'], string | null> = {
  'en-stock': null,
  'dernieres-pieces': 'Dernières pièces',
  epuise: 'Épuisé'
};
export function ProductCard({
  product
}: {
  product: Product;
}) {
  const {
    add
  } = useCart();
  const soldOut = product.stock === 'epuise';
  const badge = stockLabel[product.stock];
  return <article className="group flex h-full flex-col" data-id="element-106" data-mp="pbg211pghpss">
      <div className="relative overflow-hidden rounded-lg bg-parchment" data-id="element-107" data-mp="p9v6p9vbi2tv">
        <img src={product.image} alt={product.name} className="aspect-[4/3] w-full object-cover transition-transform duration-300 ease-soft group-hover:scale-[1.03]" loading="lazy" data-id="element-108" data-mp="tecq37xrme44" />
        {badge && <span className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-[11px] font-medium ${soldOut ? 'bg-ink/80 text-cream' : 'bg-cream text-clay'}`} data-id="element-109" data-mp="303ray91v457f">
            {badge}
          </span>}
      </div>

      <h3 className="mt-4 font-display text-lg leading-snug text-ink" data-id="element-110" data-mp="3gyucgxubm3f2">{product.name}</h3>
      <p className="mt-1 text-sm text-muted" data-id="element-111" data-mp="3cz20eb5pxf4y">{product.unit}</p>
      <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-112" data-mp="37zz5hjjgcpap">{product.description}</p>

      <div className="mt-auto flex items-center justify-between gap-3 pt-5" data-id="element-113" data-mp="8k28yt0kfoid">
        <span className="font-display text-lg text-ink tabular-nums" data-id="element-114" data-mp="8hzkweiz45ga">{formatPrice(product.price)}</span>
        <button type="button" disabled={soldOut} onClick={() => add(product)} className="inline-flex items-center gap-1.5 rounded-full border border-ink px-3.5 py-2 text-sm font-medium text-ink transition-colors duration-150 ease-soft hover:bg-ink hover:text-cream disabled:cursor-not-allowed disabled:border-line disabled:text-line disabled:hover:bg-transparent disabled:hover:text-line" data-id="element-115" data-mp="4gw6lwgkqhh6">
          <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-116" data-mp="2grp5zysc2asp" />
          {soldOut ? 'Épuisé' : 'Ajouter'}
        </button>
      </div>
    </article>;
}